export default __webpack_public_path__ + "static/media/map.c1152862.svg";